let player: HTMLAudioElement | null = null;
let muted = false;
let ducked = false;

let musicVolume = 0.18;

function syncVolume() {
  if (!player) return;
  player.volume = muted ? 0 : ducked ? musicVolume * 0.22 : musicVolume;
}

export async function startMusic() {
  if (muted || typeof window === "undefined") return;
  player ??= (() => {
    const audio = new Audio("/audio/island-bgm.mp3");
    audio.loop = true;
    audio.preload = "auto";
    return audio;
  })();
  syncVolume();
  try {
    await player.play();
  } catch {
    // Mobile browsers can block autoplay. Stay silent instead of using an
    // electronic oscillator that sounds unlike the island.
  }
}

export function setMusicDucked(value: boolean) {
  ducked = value;
  syncVolume();
}

export function setMusicMuted(value: boolean) {
  muted = value;
  syncVolume();
}

export function setMusicVolume(value: number) {
  musicVolume = Math.max(0, Math.min(0.25, Number.isFinite(value) ? value : 0.18));
  syncVolume();
}

export function stopMusic() {
  if (!player) return;
  player.pause();
  player.currentTime = 0;
}
